import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MetaTags from '../components/MetaTags';
import { getBreadcrumbSchema } from '../utils/schemaGenerator';
import { useTheme } from '../context/ThemeContext';

const AIStudioPage = () => {
  const { theme } = useTheme();
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'AI Studio', url: '/ai-studio' }
  ]);

  return (
    <>
      <MetaTags
        title="AI Audition Studio & Script Analysis | BookMyAudition"
        description="Revolutionary AI tools for actors. Instant AI audition scoring, script analysis, and audition preparation tools on BookMyAudition."
        keywords="AI audition studio, AI script analysis, acting AI tools, actor audition scoring, BookMyAudition AI"
        canonical="https://web.bookmyaudition.com/ai-studio"
        schema={breadcrumbSchema}
      />
      <div 
        className="ai-studio-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                AI Studio
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                Revolutionary AI tools designed for the modern actor. From AI-driven script analysis to virtual practice partners, elevate your craft with technology.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <div 
                  className="badge px-3 py-2 rounded-pill mb-3" 
                  style={{ backgroundColor: 'rgba(230, 57, 70, 0.15)', color: '#e63946', fontSize: '0.9rem', fontWeight: 600 }}
                >
                  🚀 IN DEVELOPMENT
                </div>
                <h3 className="fw-bold mb-3">Next-Gen Acting Tools</h3>
                <p className="text-muted">
                  We are building AI script breakdown engines, monologue performance scoring, and automated rehearsal assistants.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AIStudioPage;